import { useMantineTheme } from '@mantine/core';

import ContestCountdown from "~/components/utils/ContestCountdown";
import { Text } from '~/domains/design-system/Text';

function ContestDeadlineColumn({ start_date }: { start_date: Date }) {
  const theme = useMantineTheme();

  return (
    <Text
      variant="body-medium"
      color={theme.colors.gray[8]}
    >
      <ContestCountdown
        contestStart={start_date}
        color={null}
        fontSize={null}
      />
    </Text>
  )
}

export default ContestDeadlineColumn;
